export const CONVERT_CONTENT = (content) => {
    return { __html: content };
};
